module.exports = __webpack_public_path__ + "img/grass.a99bfc1e.png";